/* eslint-disable jsdoc/require-description */
/* eslint-disable class-methods-use-this */

/**
 * This module simply provides a promise wrapper around the
 * the callback based async functions in auth0-js
 */
import { WebAuth as Authentication } from 'auth0-js';

/**
 * Converts a callback style async function into a promise returning async function
 *
 * @param   {((err: any, result: any) => void)} fn
 *
 * @returns {Promise<any>}
 * @private
 */
function fromCallback(fn) {
  return new Promise((resolve, reject) => {
    fn((err, result) => {
      if (err) reject(err);else resolve(result);
    });
  });
}
export class WebAuth {
  constructor( /** @type {import('auth0-js').AuthOptions} */options) {
    this.auth0 = new Authentication(options);
  }
  authorize( /** @type {import('auth0-js').AuthorizeOptions} */options) {
    return this.auth0.authorize(options);
  }
  async changePassword( /** @type {import('auth0-js').ChangePasswordOptions} */options) {
    return fromCallback(cb => this.auth0.changePassword(options, cb));
  }
  async checkSession( /** @type {import('auth0-js').CheckSessionOptions} */options) {
    return fromCallback(cb => this.auth0.checkSession(options, cb));
  }
  logout( /** @type {import('auth0-js').LogoutOptions} */options) {
    return this.auth0.logout(options);
  }
  async parseHash( /** @type {import('auth0-js').ParseHashOptions} */options) {
    return fromCallback(cb => this.auth0.parseHash(options, cb));
  }
}